import { inject, Injectable } from '@angular/core'
import { map, Observable } from 'rxjs'
import { HttpClient } from '@angular/common/http'
import { environment } from '../../../../environments/environment'
import { ParamDto } from './dto/param-dto'
import { SaveParamDto } from './dto/save-param.dto'
import { decodeBase64 } from '../../utils/utils'
import { ParamCodeEnum } from '../../models/enums/param-code.enum'

@Injectable({
    providedIn: 'root',
})
export class ParamHttpService {
    private static readonly url = environment.baseUrl + '/param'
    private readonly http = inject(HttpClient)

    private readonly encodedParamsCode = [ParamCodeEnum.globalMessage, ParamCodeEnum.globalMessageIris]

    private decodeParams(params: ParamDto[]): ParamDto[] {
        return params.map((p) => ({
            ...p,
            valeurParam: this.encodedParamsCode.includes(p.codeParam as ParamCodeEnum)
                ? decodeBase64(p.valeurParam)
                : p.valeurParam,
        }))
    }

    getParams(): Observable<ParamDto[]> {
        return this.http
            .get<ParamDto[]>(ParamHttpService.url + '/params')
            .pipe(map((params) => this.decodeParams(params)))
    }

    saveParams(params: SaveParamDto[]): Observable<ParamDto[]> {
        return this.http
            .post<ParamDto[]>(ParamHttpService.url + '/params', params)
            .pipe(map((params) => this.decodeParams(params)))
    }
}
